<template>
  <div>
    <img src="@/assets/img/bj_1.png" class="bjImg" alt="">
    <div class="boxCont">
      <img src="@/assets/img/s_1.png" class="boxCont_1 animate__animated animation_title" alt="">
      <div class="boxCont_2 animate__animated animation_title">用心服务 每一刻都<span>闪耀光彩</span></div>
      <div class="boxCont_3 animate__animated animation_title" @click="companyDetails">公司介绍</div>
    </div>
  </div>
</template>

<script>
  // Created by www.xingnuocn.com
  // @title: 首页
  // @author: 刘嘉鑫
  export default {
    data() {
      return {
      }
    },
    mounted() {
     
    },
    methods: {
      // 项目介绍
      companyDetails() {
        this.$router.push({
          path: "companyDetails",
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  .bjImg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .boxCont {
    position: relative;
    z-index: 99;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 143px;

    .boxCont_1 {
      width: 706px;
      height: 347px;
    }

    .boxCont_2 {
      font-weight: 700;
      font-size: 21px;
      color: #FFFFFF;
      letter-spacing: 10px;
      margin-top: -80px;
      margin-bottom: 90px;
      margin-left: 30px;

      span {
        color: #F02874;
      }
    }

    .boxCont_3 {
      background: #0057FE;
      border-radius: 66px;
      padding: 13px 30px;
      font-weight: 700;
      font-size: 17px;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
</style>